/**
 * Whether the browser has the Popover API (Safari 17+, Firefox 125+, Chrome 114+).
 * Always false on the server; only use it in effects and event handlers.
 * The CSS uses @supports selector(:popover-open) for the same check.
 */
export const supportsPopover = typeof HTMLElement !== "undefined" && "popover" in HTMLElement.prototype;
